import { cn } from '@/lib/utils';
import {
  CanonicalTaskStatus,
  TaskStatusColors,
} from '@/services/types/task-types';

type TaskStatusDisplayProps = {
  status: CanonicalTaskStatus;
  label?: string;
  compact?: boolean;
  className?: string;
};

const getStatusLabel = (status: CanonicalTaskStatus): string => {
  switch (status) {
    case CanonicalTaskStatus.IN_PROGRESS:
      return 'Active';
    case CanonicalTaskStatus.COMPLETED:
      return 'Done';
    case CanonicalTaskStatus.BLOCKED:
      return 'Blocked';
    case CanonicalTaskStatus.NOT_APPLICABLE:
      return 'N/A';
    case CanonicalTaskStatus.CLOSED:
      return 'Closed';
    case CanonicalTaskStatus.PENDING:
    default:
      return 'Todo';
  }
};

export const TaskStatusDisplay = ({
  status,
  label,
  compact = false,
  className,
}: TaskStatusDisplayProps) => {
  return (
    <span
      className={cn(
        compact ? 'text-[10px] py-0.5 px-1.5' : 'text-xs py-1 px-2',
        'rounded font-medium',
        TaskStatusColors[status],
        className,
      )}
    >
      {label || getStatusLabel(status)}
    </span>
  );
};
